export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10172.247a0425.jpg";